import compareDesc from 'date-fns/compareDesc';
import API from '@/api';
import V3API from '@/api/v3';

const RESET_STATE = 'RESET_STATE';

const GET_SHOTS = 'GET_SHOTS';
const GET_SHOTS_SUCCESS = 'GET_SHOTS_SUCCESS';
const GET_SHOTS_FAILED = 'GET_SHOTS_FAILED';

const GET_ACTIONS = 'GET_ACTIONS';
const GET_ACTIONS_SUCCESS = 'GET_ACTIONS_SUCCESS';
const GET_ACTIONS_FAILED = 'GET_ACTIONS_FAILED';

const GET_HYBRID_SHOT = 'GET_HYBRID_SHOT';
const GET_HYBRID_SHOT_FAILED = 'GET_HYBRID_SHOT_FAILED';
const GET_HYBRID_SHOT_SUCCESS = 'GET_HYBRID_SHOT_SUCCESS';

const GET_SHOT_GROUP_LIST = 'GET_SHOT_GROUP_LIST';
const GET_SHOT_GROUP_LIST_FAILED = 'GET_SHOT_GROUP_LIST_FAILED';
const GET_SHOT_GROUP_LIST_SUCCESS = 'GET_SHOT_GROUP_LIST_SUCCESS';

const GET_SHOT_GROUP_GET = 'GET_SHOT_GROUP_GET';
const GET_SHOT_GROUP_GET_FAILED = 'GET_SHOT_GROUP_GET_FAILED';
const GET_SHOT_GROUP_GET_SUCCESS = 'GET_SHOT_GROUP_GET_SUCCESS';

const UPDATE_SHOT_GROUP_COLLECTION = 'UPDATE_SHOT_GROUP_COLLECTION';
const UPDATE_SHOT_GROUP_COLLECTION_FAILED = 'UPDATE_SHOT_GROUP_COLLECTION_FAILED';
const UPDATE_SHOT_GROUP_COLLECTION_SUCCESS = 'UPDATE_SHOT_GROUP_COLLECTION_SUCCESS';

const namespaced = true;

function playerColor(index) {
  console.log('index:', index);
  if (!index) return;
  switch (index) {
    case 0:
      return 'red';
    case 1:
      return 'blue';

    default:
      return null;
  }
}

const state = {
  all: [],
  actions: [],
  shotData: [],
  shotGroup: {},
  shotGroupSessions: [],
  loading: false,
  loadingActions: false,
  loadingShotGroupCollections: false,
  loadingShotGroup: false,
};

const emptyState = {
  all: [],
  actions: [],
  shotData: [],
  shotGroup: {},
  shotGroupSessions: [],
  loading: false,
  loadingActions: false,
  loadingShotGroupCollections: false,
  loadingShotGroup: false,
};

const getters = {
  shotList: (state) => {
    return state.all;
  },

  actionsList: (state) => {
    return state.actions;
  },

  shotData: (state) => {
    return state.shotData;
  },

  loading: (state) => {
    return state.loading;
  },

  // * Shot Groups
  // shotGroupList: (state) => {
  //   return state.shotGroupList;
  // },

  shotGroupSessions: (state) => {
    return state.shotGroupSessions;
  },

  loadingShotGroupCollections: (state) => {
    return state.loadingShotGroupCollections;
  },
};

const actions = {
  //* reset state
  async resetState({ commit }) {
    commit(RESET_STATE);
  },

  //* all fetches the shot list from the API for a given round
  async all({ commit }, { roundID, userID, bestBall = false, scramble = false }) {
    // console.log('scramble:', scramble);
    // console.log('bestBall:', bestBall);
    let response = {};
    let actionsList = [];

    commit(GET_SHOTS);

    try {
      response = await API.shots.list(roundID);

      //! Use this to merge actions into shot list
      actionsList = await API.shots.actions(roundID);

      if (actionsList?.data?.length > 0) {
        // const { userID } = response.data?.[0] || ''; //* didn't always get correct userID
        response.data = response.data
          .concat(
            actionsList.data
              .filter((action) => {
                // console.log('action:', action);
                if (!action?.actionIndex && action?.actionIndex !== 0) {
                  return false;
                }
                if (bestBall) {
                  return action?.userID;
                }
                if (scramble) {
                  return action.actionReason !== 'SelectBestBall_DTP';
                }
                return userID ? action.userID === userID : true;
              })
              .map((action) => {
                return {
                  ...action,
                  roundScore: action?.roundScore ? action.roundScore : action.RoundScore,
                };
              })
          )
          .sort((a, b) => {
            if (a.segmentScoreIndex === b.segmentScoreIndex) {
              return a.actionIndex < b.actionIndex ? -1 : 1;
            }
            return a.segmentScoreIndex < b.segmentScoreIndex ? -1 : 1;
          });
        //* Original setup. new setup sorts by both actionIndex and segmentScoreIndex
        // .sort((a, b) => {
        //   return a.actionIndex - b.actionIndex;
        // });
      }

      //* Alternate to returning Promise and just using async/await
      //* and throwing and Error with request not completing.
      //* Leaving in for now just because.
      // if (response.status >= 400) {
      //   commit(GET_SHOTS_FAILED)
      //   throw new Error('Sorry, your request could not be completed')
      // } else {
      //   commit(GET_SHOTS_SUCCESS, response.data)
      //   console.log('response', response.data.length)
      // }
    } catch (err) {
      // console.log('failed response', err)
      // commit(GET_SHOTS_FAILED)
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response?.status >= 400) {
        commit(GET_SHOTS_FAILED);
        reject(response);
      } else {
        commit(GET_SHOTS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* actions fetches the shot action records from the API for a given round
  async actions({ commit }, roundID) {
    let response;

    commit(GET_ACTIONS);

    try {
      response = await API.shots.actions(roundID);
      // console.log('response:', response);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ACTIONS_FAILED);
        reject(response);
      } else {
        commit(GET_ACTIONS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* shotview fetches the shot details for a given shot ID. Used for nexus golf and top view display
  async shotview({ commit }, shotID) {
    let response;

    commit(GET_HYBRID_SHOT);

    try {
      response = await API.shots.shotview(shotID);
      // console.log('response:', response);

      if (!response.data) {
        response.data = [];
      }

      response.data = response?.data
        ?.map((shot) => {
          const newName = shot.display_name.replace('Guest.', 'Player ');
          //* Setup to get player color by index
          // const playerIndex = shot?.display_name?.split('.')?.[1];
          // let playerColor = null;
          // switch (playerIndex) {
          //   case '0':
          //     playerColor = '#BA2127'; // red
          //     break;
          //   case '1':
          //     playerColor = '#356DC0'; // blue
          //     break;
          //   case '2':
          //     playerColor = '#FFCC00'; // yellow
          //     break;
          //   case '3':
          //     playerColor = '#35C09B'; // green
          //     break;
          //   case '4':
          //     playerColor = 'orange';
          //     break;
          //   case '5':
          //     playerColor = 'grey';
          //     break;
          //   case '6':
          //     playerColor = 'purple';
          //     break;
          //   case '7':
          //     playerColor = 'pink';
          //     break;
          //   default:
          //     playerColor = null;
          // }
          // return { ...shot, display_name: newName, playerColor };
          return { ...shot, display_name: newName };
        })
        .sort((a, b) => {
          return Date.parse(b.created_at) - Date.parse(a.created_at);
        });
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_HYBRID_SHOT_FAILED);
        reject(response);
      } else {
        commit(GET_HYBRID_SHOT_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * ===================== V3 =========================================
  // * shotGroupList returns the list of shot groups for a user
  async shotGroupList({ commit }, payload) {
    let response;
    commit(GET_SHOT_GROUP_LIST);

    try {
      response = await V3API.shots.shotGroupList(payload);
      // response.data = orSessions;
      // response.data = newSessions;
    } catch (err) {
      response = err;
    }
    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SHOT_GROUP_LIST_FAILED);
        reject(response);
      } else {
        commit(GET_SHOT_GROUP_LIST_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * shotGroupCollectionList returns the list of shot groups and sessions for a user
  async shotGroupCollectionList({ commit }, payload) {
    const { noLoad = false } = payload;
    let response;

    if (!noLoad) {
      commit(GET_SHOT_GROUP_LIST);
    }

    try {
      response = await V3API.shots.shotGroupCollectionList(payload);

      if (response?.data?.collections?.length) {
        response.data.collections = response.data.collections.map((session) => {
          return {
            ...session,
            active: session.status === 'active',
          };
        });
      }
    } catch (err) {
      response = err;
    }
    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SHOT_GROUP_LIST_FAILED);
        reject(response);
      } else {
        commit(GET_SHOT_GROUP_LIST_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * shotGroupGet returns the shot group by id for a user
  async shotGroupGet({ commit }, payload) {
    let response;
    commit(GET_SHOT_GROUP_GET);

    try {
      response = await V3API.shots.shotGroupGet(payload);
    } catch (err) {
      response = err;
    }
    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SHOT_GROUP_GET_FAILED);
        reject(response);
      } else {
        commit(GET_SHOT_GROUP_GET_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * shotGroupUpsert updates a shot group
  async shotGroupUpsert({ commit }, payload) {
    let response;
    commit(GET_SHOT_GROUP_GET);

    try {
      response = await V3API.shots.shotGroupUpsert(payload);
    } catch (err) {
      response = err;
    }
    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SHOT_GROUP_GET_FAILED);
        reject(response);
      } else {
        commit(GET_SHOT_GROUP_GET_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * shotGroupCollectionUpdate updates a shot collection
  async shotGroupCollectionUpdate({ commit }, payload) {
    let response;
    commit(UPDATE_SHOT_GROUP_COLLECTION);

    try {
      response = await V3API.shots.shotGroupCollectionUpdate(payload);
    } catch (err) {
      response = err;
    }
    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(UPDATE_SHOT_GROUP_COLLECTION_FAILED);
        reject(response);
      } else {
        commit(UPDATE_SHOT_GROUP_COLLECTION_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },
};

const mutations = {
  [RESET_STATE](state) {
    state = emptyState;
  },

  [GET_SHOTS](state) {
    state.loading = true;
  },

  [GET_SHOTS_SUCCESS](state, shots) {
    state.all = shots;
    state.loading = false;
  },

  [GET_SHOTS_FAILED](state) {
    state.loading = false;
  },

  [GET_ACTIONS](state) {
    state.loading = true;
  },

  [GET_ACTIONS_SUCCESS](state, payload) {
    state.actions = payload;
    state.loading = false;
  },

  [GET_ACTIONS_FAILED](state, payload) {
    state.loading = false;
  },

  [GET_HYBRID_SHOT](state) {
    state.loading = true;
  },

  [GET_HYBRID_SHOT_SUCCESS](state, payload) {
    state.shotData = payload;
    state.loading = false;
  },

  [GET_HYBRID_SHOT_FAILED](state) {
    state.loading = false;
  },

  [GET_SHOT_GROUP_LIST](state) {
    state.loadingShotGroupCollections = true;
  },

  [GET_SHOT_GROUP_LIST_FAILED](state) {
    state.loadingShotGroupCollections = false;
  },

  [GET_SHOT_GROUP_LIST_SUCCESS](state, payload) {
    state.shotGroupSessions = payload;
    // state.shotGroupList = payload;
    state.loadingShotGroupCollections = false;
  },

  [GET_SHOT_GROUP_GET](state) {
    state.loadingShotGroup = true;
  },

  [GET_SHOT_GROUP_GET_FAILED](state) {
    state.loadingShotGroup = false;
  },

  [GET_SHOT_GROUP_GET_SUCCESS](state, payload) {
    state.shotGroup = payload;
    state.loadingShotGroup = false;
  },

  [UPDATE_SHOT_GROUP_COLLECTION](state) {
    // state.loadingShotGroup = true;
  },

  [UPDATE_SHOT_GROUP_COLLECTION_FAILED](state) {
    // state.loadingShotGroup = false;
  },

  [UPDATE_SHOT_GROUP_COLLECTION_SUCCESS](state, payload) {
    // state.shotGroup = payload;
    // state.loadingShotGroup = false;
  },
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
